export default "__VITE_ASSET__BelCIy62__"